import firebase from 'firebase/app';
import "./App.css";
import "firebase/firestore";
import "firebase/auth";
import {useAuthState} from "react-firebase-hooks/auth"
import {useCollectionData} from "react-firebase-hooks/firestore"
import { useRef, useState } from 'react';


firebase.initializeApp({
  // config
  apiKey: "AIzaSyDZIxTOo9WDcvOB_krl52UInzygOf2p8xc",
    authDomain: "codesome-area51.firebaseapp.com",
    projectId: "codesome-area51",
    storageBucket: "codesome-area51.appspot.com",
    messagingSenderId: "688653377771",
    appId: "1:688653377771:web:841201a88644a26bf19eae",
    measurementId: "G-7F7PEEQ0DY"
})

const firestoreDb = firebase.firestore();
const auth = firebase.auth();


function App() {
  const [user] = useAuthState(auth);

  return (
    <div className="App">
      <header className="App-header">
       <h1 className="title">Area 51🛸</h1>
       <Signout />
      </header>
      <section className="conatiner">
        {user ? <Chatroom /> : <SignIn />}
      </section>
    </div>
  );
}

const SignIn = () => {

  const googleSignin = () =>{
    const provider = new firebase.auth.GoogleAuthProvider();
    auth.signInWithPopup(provider);
  }

  return (
    <div>
       <button onClick={googleSignin} className="sign-in">Chat With Aliens</button>
    </div>
  )
}

const Signout = () =>{
  return auth.currentUser && (
    <button onClick={() => auth.signOut()} className="signout">Signout</button>
  )
}

const Chatroom = () => {
  const dummy = useRef();
  const messagesRef = firestoreDb.collection('messages');
  const query = messagesRef.orderBy('createdAt').limit(30);
  const [messages] = useCollectionData(query, { idField: 'id' });
  const [formValue,setFormValue] = useState("");
  const {uid, photoURL} = auth.currentUser;

 

  const sendMessage = async(e) =>{
    e.preventDefault();

    await messagesRef.add({
      text: formValue,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      uid,
      photoURL,
    });

    setFormValue("");

    dummy.current.scrollIntoView({ behavior: 'smooth' });
  } 

  return (
    <div>
     <main>
     <div className="chat">
       {messages && messages.map(msg => <ChatMessage key={msg.id} message={msg} photoURL={msg.photoURL} />)}
     </div>

     <div ref={dummy}></div>
     </main>
    

     <form className="sendMessage" onSubmit={sendMessage}>
       <input type="text" value={formValue} onChange={(e)=> setFormValue(e.target.value)} />
       <button className="sendButton" type="submit">👽</button>
       </form>
  
    </div>
  )
}

const ChatMessage = (props) =>{
  const {text,uid,photoURL} = props.message;
  const messageClass = uid === auth.currentUser.uid ? "sent" : "received";

  return (
    <div className={`message ${messageClass}`}>
    <img src={photoURL } alt="" />
    <p>{text} </p>
    </div>

// || "https://joeschmoe.io/api/v1/random"
  )
}
export default App;
